import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { AuthAppService } from 'avn/modules/services/auth-app/auth-app.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoginGuard implements CanActivate {
  public constructor(
    private readonly router: Router,
    private readonly auth: AuthAppService
  ) {}
  public canActivate(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (this.auth.isLoggedIn || this.auth.isBackendLoggedIn) {
      return true;
    }
    void this.router.navigateByUrl('/login');
    return false;
  }
}
